import React,{Component} from 'react';

import Wrapper from '../Wrapper';

import './Images.less';

const IMAGES_TO_DISPLAY = 4;

class Images extends Component{
  constructor(props){
    super(props);

    const {instagram,image_galleries} = props.data;

    let menu = [];

    if(image_galleries){
      menu = ['Instagram',...image_galleries.map(el => el.title)];
    }

    this.state = {
        menu: menu.length > 1 ? menu: null,
        current_gallery: menu.length > 1 ? menu[0] : 'Instagram',
        activeIndex: 0
    }
  }

  switchType = (network) => {
    this.setState({
      current_gallery: network,
    })
  }

  render(){
    const {menu,current_gallery} = this.state;
    const {instagram, image_galleries} = this.props.data;

    return (
      <Wrapper title="Fotos"
      menuItems={menu}
      menuAction={menu ? this.switchType : null}
      fullwidth {...this.props}>
        <div className={`image-container ${this.props.res}`}>
        {
          current_gallery == 'Instagram'
          ? instagram.map((image,idx) => <InstagramImage key={image.id} {...image} />)
          : image_galleries.filter(el => el.title == current_gallery)[0].images.map((image,idx) => <Image key={image.sizes.thumbnail} {...image} />)
        }
        </div>
      </Wrapper>
    )
  }
}

export default Images;

const InstagramImage = ({standard_resolution,content,link,user}) => {
  const {profile_picture,full_name} = user || {};
  return (
    <a href={link} target="_blank" className='image instagram'>
      <img src={standard_resolution} />
      {profile_picture && full_name && <div className='instagram-profile'><img className='instagram-profile-pic' src={profile_picture} /> {full_name}</div>}
      <p>{content}</p>
    </a>
  )
}

const Image = ({sizes,author}) => {
  return (
    <div className='image'>
      <img src={sizes.large} />
      {author && <p>Fotograf: {author}</p>}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/sections/Images.js